import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/projects/image1.jpg")